import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';

import { AdvanceDetailBody } from '../components/advance/AdvanceDetailBody';
import { PageHead } from '../components/layout';
import { useAdvance } from '../lib/queries/advances';
import { useActiveCompanyId } from '../lib/queries/companies';

export const Route = createFileRoute('/advance/$id')({
  component: AdvanceDetailPage,
});

function AdvanceDetailPage() {
  const { id } = useParams({ from: '/advance/$id' });
  const companyId = useActiveCompanyId();
  const navigate = useNavigate();
  const { data: advance, isPending, error } = useAdvance(companyId, id);

  return (
    <div className="page">
      <PageHead
        crumbs={['ลูกหนี้ / เจ้าหนี้', 'เงินทดรองจ่าย', advance?.voucherNo ?? '…']}
        title="รายละเอียดเงินทดรองจ่าย"
        actions={
          <button className="btn" onClick={() => void navigate({ to: '/advance' })}>
            ← กลับ
          </button>
        }
      />
      {isPending && (
        <div className="muted" style={{ padding: 24, textAlign: 'center' }}>
          กำลังโหลด…
        </div>
      )}
      {error && (
        <div className="neg" style={{ padding: 24, textAlign: 'center' }}>
          โหลดไม่สำเร็จ: {error.message}
        </div>
      )}
      {!isPending && !error && advance && <AdvanceDetailBody advance={advance} />}
    </div>
  );
}
